import React, { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../../context/AuthContext';
import RejectedAgentContainer from './components/RejectedRestaurantContainer';
import HeartRate from './HeartRate';
import CaloriesBurn from './CaloriesBurn';
import Distance from './Distance';
import Steps from './Steps';
import Bar from './Bar';

const Dashboard = () => {
    const { statusCode, restaurantid } = useContext(AuthContext);
      const { t } = useTranslation('common');


    return (
      <div>
        {(statusCode === '0' || statusCode === '2') ? (
          <RejectedAgentContainer restaurantid={restaurantid} statusCode={statusCode} />
        ) : null}
        <Container>
          <Row>
            {/* <Col md={12}>
              <h3 className="page-title">{t('fitness_dashboard.page_title')}</h3>
            </Col> */}
          </Row>
          <Row>
            {/* <HeartRate />
            <CaloriesBurn />
            <Distance />
            <Steps />
            <Bar /> */}
            {/* <Steps />
            <Distance /> */}
          </Row>
          {/* <Row>
            <ActivityChart dir={rtl.direction} />
            <TodayRunningMap />
            <MyCompetitors />
            <FatBurning dir={rtl.direction} />
            <ActivityRating dir={rtl.direction} />
          </Row> */}
        </Container>
      </div>
    );
};

export default Dashboard;
